module.exports = __webpack_public_path__ + "static/3-55d0dcc4baaf165403562f6eed91291e.jpeg";